import axios from "axios";

const forceLogout = () => {
  const keysToRemove = [
    'isAuthenticated', '2faVerified', 'login_id', 'auth_token', 
    'login_name', 'dashboardNotificationClosed', 'dashboardNotificationIndex',
    'twofa_token', 'twofa_questions', 'twofa_type', '2fa_lockout_expiry', 
    '2fa_setup_required', 'token'
  ];
  keysToRemove.forEach(key => localStorage.removeItem(key));
  sessionStorage.removeItem('zoho_autoopen_support');
  window.location.replace('/login');
};

const AllowedEndpointCalls = {
  // required for guest login
  "/api/v1/user/login/otp": ["POST"],
  "/api/v1/account": ["GET", "POST", "PUT", "DELETE"],
  "/api/v1/account/preferences": ["GET"],
  "/api/v1/search": ["GET"],
  "/api/v1/marketwatch": ["GET"],
  "/api/v1/symbol-lists": ["GET", "DELETE", "PUT"],
  "/api/v1/marketwatch/instrument": ["POST"],
  "/api/v2/theme": ["GET"],
  "/api/v1/contract/NSE": ["GET"],
  "/api/v1/contract/BSE": ["GET"],
  "/api/v1/contract/BFO": ["GET"],
  "/api/v1/contract/CDS": ["GET"],
  "/api/v1/contract/NFO": ["GET"],
  "/api/v1/contract/MCX": ["GET"],
  "/api/v1/user/otp/validate": ["POST"],
  "/api/v1/user/twofa": ["POST"],
  "/api/v4/user/twofa": ["POST"],
  "/api/v4/user/twofa/forgot": ["POST"],
  "/api/v4/user/twofa/forgot/validate/otp": ["POST"],
  "/api/kyc/v1/send-otp/email": ["POST"],
  "/api/kyc/v1/verify-otp/email": ["POST"],
  "/api/kyc/v1/kra-details": ["POST"],
  "/api/kyc/v1/send-otp/sms": ["POST"],
  "/api/kyc/v1/verify-otp/sms": ["POST"],
  "/api/kyc/v1/user/address": ["PUT"],
  "/api/kyc/v1/user/personal-details": ["POST"],
  "/api/kyc/v1/digilocker-auth-token": ["GET"],
  "/api/kyc/v1/verify-bank-account": ["POST"],
  "/api/kyc/v1/kycdetails": ["GET"],
  "/api/kyc/v2/readKYC": ["POST"],
  "/api/kyc/v1/uploadKYC": ["POST"],
  "/api/kyc/v1/user/nominees": ["GET", "POST", "PATCH", "DELETE"],
  "/api/kyc/v2/user/nominee": ["POST"],
  "/api/kyc/v1/kid-details": ["POST"],
  "/api/kyc/v1/esign-download": ["POST"],
  "/api/kyc/v1/digilocker-esign-request-id": ["GET"],
  "/api/kyc/v1/subscription-plans": ["GET", "PUT"],
  "/api/kyc/v1/user/subscription-plan": ["PUT"],
  "/api/kyc/v1/master/basan": ["GET"],
  "/api/kyc/v1/derivatives": ["POST"],
  "/api/kyc/v1/experience": ["GET"],
  "/api/v1/user/account/freeze":["POST"],
  "/api/v1/basket": ["GET", "POST", "PUT", "DELETE"]
};

const getHeaders = (isForgotPassword = false) => ({
  "x-authorization-token":localStorage.getItem("auth_token"),
  "x-device-type": "web",
});
// const baseURL =  process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : window.location.host;

const getFormDataHeaders = () => ({
  "x-authorization-token": localStorage.getItem("token"),
  "x-device-type": "web",
  "Content-Type": "multipart/form-data",
});

export function contraAPI({ method, endpoint, params, data, headers, isForgotPassword = false }) {
  return new Promise((resolve, reject) => {
    if (
      localStorage.getItem("user_type") !== "GUEST" ||
      (AllowedEndpointCalls &&
        AllowedEndpointCalls.hasOwnProperty(endpoint) &&
        AllowedEndpointCalls[endpoint].includes(method))
    ) {
      axios({
        method,
        // baseURL,
        url: endpoint,
        headers: {
          ...getHeaders(isForgotPassword),
          ...(headers || {}),
          "x-device-type": "web",
        },
        params,
        data,   
      })
        .then((resp) => {
          const data = resp.data || {};
          const error = data.error || {};
          if (error.code === 0) {
            resolve(data);
          } else {
            reject(error.message || "request failed");
          }
        })
        .catch((err) => {
          const errorResponse = (err && err.response) || {};
          if (errorResponse.data && errorResponse.data.message) {
            reject(errorResponse.data.message);
          } else {
            reject(errorResponse.statusText);
          }
        });
    } else {
      reject("Action not allowed for guest user.");
    }
  });
}

export function contraAPINew({ method, endpoint, params, data, headers }) {
  return new Promise((resolve, reject) => {
    if (
      localStorage.getItem("user_type") !== "GUEST" ||
      (AllowedEndpointCalls &&
        AllowedEndpointCalls.hasOwnProperty(endpoint) &&
        AllowedEndpointCalls[endpoint].includes(method))
    ) {
      axios({
        method,
        // baseURL,
        url: endpoint,
        headers: {
          ...getHeaders(),
          ...(headers || {}),
          "x-device-type": "web",
        },
        params,
        data,
      })
        .then((resp) => {
          const data = resp.data || {};
          if (data.status === "success" || (data.success || data.success === "true")) {
            resolve(data);
          } else if (data.status === "error" || !data.success) {
            reject(data.message || "error");
          } else {
            reject("Invalid response");
          }
        })
        .catch((err) => {
          const errorResponse = (err && err.response) || {};
          if (errorResponse.data && errorResponse.data.message) {
            reject(errorResponse.data.message);
          } else {
            reject(errorResponse.statusText);
          }
        });
    } else {
      reject("Action not allowed for guest user.");
    }
  });
}

export function primusAPI({
  method,
  query,
  endpoint,
  params,
  data,
  headers,
  isForgotPassword = false,
  bypassUnauthorizedCheck = false,
}) {
  // Check if this is a download request
  const isDownloadRequest = endpoint.includes('/download') || endpoint.includes('/pnl-history/download');
  
  return new Promise((resolve, reject) => {
    if (
      localStorage.getItem("user_type") !== "GUEST" ||
      (AllowedEndpointCalls &&
        AllowedEndpointCalls.hasOwnProperty(endpoint) &&
        AllowedEndpointCalls[endpoint].includes(method))
    ) {
      axios({
        method,
        // baseURL,
        url: endpoint + (query ? "/" + query : ""),
        headers: {
          ...getHeaders(isForgotPassword),
          ...(headers || {}),
          "x-device-type": "web",
        },
        params,
        data,
        responseType: isDownloadRequest ? 'blob' : 'json', // Set responseType to 'blob' for download requests
      })
        .then((resp) => {
          // For download requests, resolve with the response data directly
          if (isDownloadRequest && resp.data) {
            resolve(resp.data);
            return;
          }
          
          // For regular requests, process as before
          const data = resp.data || {};
          console.log("data",data);
          if (data.status === "success" || (data.success || data.success === "true")|| resp.status===200) {
            resolve(data);
          } else if (data.status === "error" || !data.success) {
            reject(data.message || "error");
          } else {
            reject("Invalid response");
          }
        })
        .catch((err) => {
          const errorResponse = (err && err.response) || {};
          if (!bypassUnauthorizedCheck && errorResponse.status === 401) {
            reject(errorResponse.statusText);
            forceLogout();
            return;
          }
          if (errorResponse.data && errorResponse.data.message) {
            reject(errorResponse.data.message);
          } else {
            reject(errorResponse.statusText);
          }
        });
    } else {
      reject("Action not allowed for guest user.");
    }
  });
}

export function MarginAPI({
  method,
  query,
  endpoint,
  params,
  data,
  headers,
  bypassUnauthorizedCheck = false,
}) {
  return new Promise((resolve, reject) => {
    // Check if the user type is not 'GUEST' or the endpoint call is allowed
    if (
      localStorage.getItem("user_type") !== "GUEST" ||
      (AllowedEndpointCalls &&
        AllowedEndpointCalls.hasOwnProperty(endpoint) &&
        AllowedEndpointCalls[endpoint].includes(method))
    ) {
      axios({
        method,
        url: endpoint + (query ? "/" + query : ""),
        headers: {
          ...(headers || getHeaders()),
          "x-device-type": "web",
        },
        params,
        data,
      })
        .then((resp) => {
          const data = resp.data || {};
          if (data.status === "success" || (data.success || data.success === "true")) {
            resolve(data);
          } else if (data.status === "error" || !data.success) {
            reject(data.message || "error");
          } else {
            reject("Invalid response");
          }
        })
        .catch((err) => {
          const errorResponse = (err && err.response) || {};
          if (!bypassUnauthorizedCheck && errorResponse.status === 401) {
            reject(errorResponse.statusText);
            forceLogout();
            return;
          }
          if (errorResponse.data && errorResponse.data.message) {
            reject(errorResponse.data.message);
          } else {
            reject(errorResponse.statusText);
          }
        });
    } else {
      reject("Action not allowed for guest user.");
    }
  });
}


export function primusLoginAPI({
  method,
  endpoint,
  params,
  data,
  headers,
  bypassUnauthorizedCheck = false,
}) {
  return new Promise((resolve, reject) => {
    axios({
      method,
      // baseURL,
      url: endpoint,
      headers: {
        ...(headers || getHeaders()),
        "x-device-type": "web",
      },
      params,
      data,
    })
      .then((resp) => {
        const data = resp.data || {};
        if (data.status === "success" || resp.status === 200) {
          resolve(data);
        } else if (data.status === "error" || !data.success) {
          reject(data.message || "error");
        } else {
          reject("Invalid response");
        }
      })
      .catch((err) => {
        const errorResponse = (err && err.response) || {};
        if (!bypassUnauthorizedCheck && errorResponse.status === 401) {
          reject(err.response.data);
          forceLogout();
          return;
        }
        if (errorResponse.data && errorResponse.data.message) {
          reject(err.response.data);
        } else {
          reject(err.response.data);
        }
      });
  });
}

export function spanCalculationAPI({
  method,
  endpoint,
  params,
  data,
  headers,
  bypassUnauthorizedCheck = false,
}) {
  return new Promise((resolve, reject) => {
    if (
      localStorage.getItem("user_type") !== "GUEST" ||
      (AllowedEndpointCalls &&
        AllowedEndpointCalls.hasOwnProperty(endpoint) &&
        AllowedEndpointCalls[endpoint].includes(method))
    ) {
      axios({
        method,
        // baseURL,
        url: endpoint,
        headers: {
          ...(headers || getHeaders()),
          "x-device-type": "web",
        },
        params,
        data,
      })
        .then((resp) => {
          const data = resp.data || {};
          if (data) {
            resolve(data);
          } else {
            reject("Invalid response");
          }
        })
        .catch((err) => {
          const errorResponse = (err && err.response) || {};
          if (!bypassUnauthorizedCheck && errorResponse.status === 401) {
            reject(errorResponse.statusText);
            forceLogout();
            return;
          }
          if (errorResponse.data && errorResponse.data.message) {
            reject(errorResponse.data.message);
          } else {
            reject(errorResponse.statusText);
          }
        });
    } else {
      reject("Action not allowed for guest user.");
    }
  });
}

export function TradeMutualIpoAPI({
  method,
  endpoint,
  params,
  data,
  headers,
  bypassUnauthorizedCheck = false,
}) {
  return new Promise((resolve, reject) => {
    if (
      localStorage.getItem("user_type") !== "GUEST" ||
      (AllowedEndpointCalls &&
        AllowedEndpointCalls.hasOwnProperty(endpoint) &&
        AllowedEndpointCalls[endpoint].includes(method))
    ) {
      axios({
        method,
        url: endpoint,
        headers: {
          ...(headers || getHeaders()),
          "x-device-type": "web",
        },
        params,
        data,
      })
        .then((resp) => {
          const data = resp.data || {};
          if (resp && resp.data) {
            resolve(data);
          } else if (data.status === "error" || !data.success) {
            reject(data.message || "error");
          } else {
            reject("Invalid response");
          }
        })
        .catch((err) => {
          const errorResponse = (err && err.response) || {};
          if (errorResponse.status === 401) {
            reject(errorResponse.statusText);
            forceLogout();
            return;
          }

          if (errorResponse.data && errorResponse.data.message) {
            reject(errorResponse.data.message);
          } else {
            reject(errorResponse.statusText);
          }
        });
    } else {
      reject("Action not allowed for guest user.");
    }
  });
}

export function KYCAPI({
  method,
  endpoint,
  params,
  data,
  headers,
  bypassUnauthorizedCheck = false,
}) {
  return new Promise((resolve, reject) => {
    if (
      localStorage.getItem("user_type") !== "GUEST" ||
      (AllowedEndpointCalls &&
        AllowedEndpointCalls.hasOwnProperty(endpoint) &&
        AllowedEndpointCalls[endpoint].includes(method))
    ) {
      axios({
        method,
        url: endpoint,
        headers: {
          ...(headers || getHeaders()),
          "x-device-type": "web",
        },
        params,
        data,
      })
        .then((resp) => {
          const data = resp.data || {};
          if (resp && resp.data) {
            resolve(data || "error");
          } else {
            reject("Invalid response");
          }
        })
        .catch((err) => {
          const errorResponse = (err && err.response) || {};
          if (errorResponse.status === 401) {
            reject(errorResponse.statusText);
            forceLogout();
            return;
          }

          if (errorResponse.data) {
            reject(errorResponse.data || "ERROR");
          }
        });
    } else {
      reject("Action not allowed for guest user.");
    }
  });
}

export function AWSRequestAPI({ method, endpoint, params, data, headers }) {
  return new Promise((resolve, reject) => {
    axios({
      method,
      url: endpoint,
      headers: {
        ...(headers || getHeaders()),
        "x-device-type": "web",
      },
      data,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function AWSFileUploadAPI({ method, endpoint, data, options }) {
  return new Promise((resolve, reject) => [
    axios
      .put(endpoint, data, options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      }),
  ]);
}

export function UploadFormDataAPI({
  method,
  endpoint,
  params,
  data,
  headers,
  bypassUnauthorizedCheck = false,
}) {
  return new Promise((resolve, reject) => {
    axios({
      method,
      url: endpoint,
      headers: {
        ...getFormDataHeaders(),
        "x-device-type": "web",
      },
      params,
      data,
    })
      .then((resp) => {
        const data = resp.data || {};
        if (resp && resp.data && resp.data.success) {
          resolve(data);
        } else if (data.status === "error" || !data.success) {
          reject(data.message || "error");
        } else {
          reject("Invalid response");
        }
      })
      .catch((err) => {
        const errorResponse = (err && err.response) || {};
        if (errorResponse.status === 401) {
          reject(errorResponse.statusText);
          forceLogout();
          return;
        }

        if (errorResponse.data && errorResponse.data.message) {
          reject(errorResponse.data.message);
        } else {
          reject(errorResponse.statusText);
        }
      });
  });
}


export function FreezeAPI({ method, endpoint, params, data, headers }) {
  return new Promise((resolve, reject) => {
    if (
      localStorage.getItem("user_type") !== "GUEST" ||
      (AllowedEndpointCalls &&
        AllowedEndpointCalls.hasOwnProperty(endpoint) &&
        AllowedEndpointCalls[endpoint].includes(method))
    ) {
      axios({
        method,
        url: endpoint,
        headers: {
          ...(headers || getHeaders()),
          "x-device-type": "web",
        },
        params,
        data,
      })
        .then((resp) => {
          const data = resp.data || {};
          const error = data.error || {};
          if (data) {
            resolve(data);
          } else {
            reject(error.message || "request failed");
          }
        })
        .catch((err) => {
          const errorResponse = (err && err.response) || {};
          if (errorResponse.data && errorResponse.data.message) {
            reject(errorResponse.data.message);
          } else {
            reject(errorResponse.statusText);
          }
        });
    } else {
      reject("Action not allowed for guest user.");
    }
  });
}
